<template>
  <page :head-text="$t('profile.profile')" head-uppercase>
    <template #leftBtn>
      <scan-code v-if="!tempAccess" @click="launchQrScan" />
    </template>
    <template #rightBtn>
      <show-menu @click="$emit('menu')" />
    </template>
    <div class="profile-wrapper mt-16 mb-auto flex flex-col justify-start items-center">
      <avatar :src="avatarSrc" show-edit @click="$emit('edit-profile')" />
      <div v-if="profile.nick_name" class="mt-4 text-xl">{{ profile.nick_name }}</div>
      <div v-if="auth.username" class="mt-1 text-xs">{{ auth.username }}</div>
      <menu-list class="mt-12" :sort-menu="menuList" @menu="handleMenuItem" />
      <menu-item :item="scanQrMenuItem" @click="launchQrScan" />
    </div>
    <bottom-nav
      :fixed="true"
      :can-scan="canScan"
      :has-rmd-sizes="hasRmdSizes"
      :active-page="activePage"
      @changed="$emit('update:active-page', $event)"
    />
  </page>
</template>

<script>
import { mapActions } from 'vuex';
import page from '@/mixins/page';
import showAvatar from '@/mixins/show-avatar';
import scanImg from '@/assets/common/menu-scan.svg';
import Avatar from '@/components/common/Avatar.vue';
import ScanCode from '@/components/common/ScanCode.vue';
import ShowMenu from '@/components/common/ShowMenu.vue';
import Page from '@/components/DefaultCloudzet/HomePage/Page.vue';
import BottomNav from '@/components/DefaultCloudzet/HomePage/BottomNav.vue';
import MenuList from '@/components/DefaultCloudzet/common/MenuList.vue';
import MenuItem from '@/components/DefaultCloudzet/common/MenuItem.vue';

export default {
  mixins: [page, showAvatar],
  components: {
    Page,
    MenuList,
    Avatar,
    MenuItem,
    BottomNav,
    ScanCode,
    ShowMenu,
  },
  props: {
    profile: Object,
    canScan: Boolean,
    recordToShow: Boolean,
    hasRmdSizes: Boolean,
    tempAccess: Boolean,
    auth: Object,
    activePage: {
      type: String,
      default: 'measurement',
    },
  },
  methods: {
    ...mapActions('app', ['launchQrScan']),
    handleMenuItem(menuItem) {
      if (menuItem.pageName === 'user-setting') {
        this.$emit('menu', { ...menuItem, directOpen: true });
      } else {
        this.$emit('menu', menuItem);
      }
    },
  },
  computed: {
    scanQrMenuItem() {
      return {
        img: scanImg,
        name: this.$t('homePage.scan_to_login'),
      };
    },
    menuList() {
      return [
        // 'avatar-shader',  TODO: add this
        'user-setting',
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-wrapper {
  color: #262626;
}
</style>
